import {Formik, Form} from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../components/formikControl/FormikControl'
import toast from 'react-hot-toast'
import {createHoliday, updateHoliday} from './api'
import {handleApiError} from '../../../helpers/errorHandler'
import FormResetBtn from '../../../components/FormResetBtn'
import FormSubmitBtn from '../../../components/FormSubmitBtn'

function HolidayForm({initialValues, onAfterSubmit}) {
  const formType = initialValues ? 'update' : 'add'

  const submitHandler = (values, {setSubmitting: setLoading}) => {
    setLoading(true)
    const toastId = toast.loading('Submitting')
    const action = formType === 'add' ? createHoliday : updateHoliday
    action(values)
      .then(() => {
        toast.success('Success', {id: toastId})
        onAfterSubmit()
      })
      .catch((err) => {
        handleApiError(err, toastId)
      })
      .then((res) => setLoading(false))
  }
  const formValues = initialValues || {
    holiday_date: '',
    academic_year: new Date().getFullYear(),
    reason: '',
  }
  return (
    <div className="px-5 py-3">
      <Formik
        initialValues={formValues}
        validationSchema={Yup.object({
          holiday_date: Yup.date()
            .test('is-4-digit-year', 'Year must be a 4-digit number', (value) => {
              if (!value) return true
              const year = value.getFullYear()
              return year >= 1000 && year <= 9999
            })
            .required('Holiday date is required'),
          academic_year: Yup.number().required('Academic year is required'),
          reason: Yup.string()
            .trim()
            .required('Occasion is required')
            .notOneOf([''], 'Occasion is Required'),
        })}
        onSubmit={submitHandler}
      >
        {({isSubmitting, resetForm, dirty, isValid}) => (
          <Form>
            <FormikControl
              control="input"
              type="date"
              required
              placeholder="Holiday Date"
              label="Holiday Date"
              name="holiday_date"
            />
            <FormikControl
              control="input"
              type="number"
              required
              placeholder="Academic year"
              label="Academic year"
              name="academic_year"
            />
            <FormikControl
              control="input"
              required
              placeholder="Occasion"
              label="Occasion"
              name="reason"
            />

            <div className="text-center pt-10">
              <FormResetBtn onClick={() => resetForm} disabled={isSubmitting} className="me-4" />

              <FormSubmitBtn disabled={!dirty || !isValid || isSubmitting} />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default HolidayForm
